import { render, staticRenderFns } from "./StackOrders.vue?vue&type=template&id=0ad16cc8&scoped=true&"
import script from "./StackOrders.vue?vue&type=script&lang=ts&"
export * from "./StackOrders.vue?vue&type=script&lang=ts&"
import style0 from "./StackOrders.vue?vue&type=style&index=0&id=0ad16cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad16cc8",
  null
  
)

export default component.exports